'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var hexToRgb = require('./hexToRgb-7c8edffc.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  overflow: hidden;\n"], ["\n  font-family: ", ";\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var List = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px;\n"])));
var getGhostStyles = function (isActive, theme) {
    var _a;
    var background = (_a = hexToRgb.hexToRgb(theme.colors.primary)) === null || _a === void 0 ? void 0 : _a.join(',');
    return "\n    padding: 12px;\n    background: " + (isActive ? "rgba(" + background + ", .1)" : theme.colors.universal.transparent) + ";\n    border: " + (isActive ? "2px solid " + theme.colors.primary : "1px solid " + theme.colors.greys.sharedDarkGrey) + ";\n    border-radius: 4px;\n    font-size: 14px;\n    line-height: 16px;\n    color: " + (isActive ? theme.colors.primary : theme.colors.greys.sharedDarkGrey) + ";\n    &:hover {\n      background: " + (isActive ? "rgba(" + background + ", .1)" : theme.colors.greys.adminGreyLight) + ";\n      border:\n        " + (isActive ? "2px solid " + theme.colors.primary : "1px solid " + theme.colors.greys.adminGreyDark) + ";\n    }\n  ";
};
var getPrimaryStyles = function (isActive, theme) { return "\n  padding: 11px;\n  font-size: 14px;\n  border: 1px solid " + (isActive ? theme.colors.primary : theme.colors.greys.adminGreyDark) + ";\n  border-radius: 5px;\n  color: " + (isActive ? theme.colors.primary : theme.colors.greys.darkGrey6) + ";\n  background: " + theme.colors.universal.transparent + ";\n"; };
var getVariantBasedStyles = function (_a) {
    var isActive = _a.isActive, variant = _a.variant, theme = _a.theme;
    switch (variant) {
        case 'ghost':
            return getGhostStyles(isActive, theme);
        default:
            return getPrimaryStyles(isActive, theme);
    }
};
var Chip = styled__default.button(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font-weight: 500;\n  margin: 0 8px 16px 8px;\n  cursor: pointer;\n  font-family: inherit;\n  ", "\n"], ["\n  font-weight: 500;\n  margin: 0 8px 16px 8px;\n  cursor: pointer;\n  font-family: inherit;\n  ", "\n"])), function (_a) {
    var isActive = _a.isActive, variant = _a.variant, theme = _a.theme;
    return getVariantBasedStyles({ isActive: isActive, variant: variant, theme: theme });
});
var HqoMultiselectChips = function (_a) {
    var options = _a.options, values = _a.values, onChange = _a.onChange, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    var handleClick = React.useCallback(function (value) { return function () {
        var result = (values === null || values === void 0 ? void 0 : values.slice()) || [];
        var removeIdx = result.findIndex(function (option) { return option === value; });
        if (removeIdx > -1) {
            result.splice(removeIdx, 1);
        }
        else {
            result.push(value);
        }
        onChange(result);
    }; }, [onChange, values]);
    return (React__default.createElement(Container, { "data-testid": "hqo-multiselect-chips-container" },
        React__default.createElement(List, null, options.map(function (option) {
            var isActive = Boolean(values === null || values === void 0 ? void 0 : values.some(function (v) { return v === option.value; }));
            return (React__default.createElement(Chip, { isActive: isActive, key: option.value, onClick: handleClick(option.value), variant: variant }, option.label));
        }))));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.HqoMultiselectChips = HqoMultiselectChips;
